export default "__VITE_ASSET__DF4wrDXE__"